import { createSlice } from '@reduxjs/toolkit'
import { getCities, getWarehouses } from './actions'

export const initialState: any = {
  cities: {
    data: [],
    loading: false,
    error: null,
  },
  warehouses: {
    data: [],
    loading: false,
    error: null,
  },
}

const novaSlice = createSlice({
  name: 'nova',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCities.pending, state => {
      state.cities.loading = true
      state.cities.error = null
    })
    builder.addCase(getCities.fulfilled, (state, { payload }) => {
      state.cities.loading = false
      state.cities.data = payload
    })
    builder.addCase(getCities.rejected, (state, { payload }) => {
      state.cities.loading = false
      state.cities.error = payload as null
    })

    builder.addCase(getWarehouses.pending, state => {
      state.warehouses.loading = true
      state.warehouses.error = null
    })
    builder.addCase(getWarehouses.fulfilled, (state, { payload }) => {
      state.warehouses.loading = false
      state.warehouses.data = payload
    })
    builder.addCase(getWarehouses.rejected, (state, { payload }) => {
      state.warehouses.loading = false
      state.warehouses.error = payload as null
    })
  },
})

export const { name, actions } = novaSlice

const novaReducer = novaSlice.reducer

export default novaReducer
